import { Product } from '@axo/shared/data-access/types';
import { RecommendationKind } from '@axo/shared/data-access/types/loan_quote_presentation';
import { Intent, Tag } from '@blueprintjs/core';
import { ReactNode } from 'react';
import styles from './RecommendationItem.module.css';
import { CreateRecommendationItemButton } from './CreateRecommendationItemButton';

const RECOMMENDATION_KIND_LABEL_MAPPING: Record<RecommendationKind, ReactNode> =
  {
    '': 'UNKNOWN',
    add_on: 'ADD-ON',
    fallback: 'FALLBACK',
  };

const RECOMMENDATION_KIND_INTENT_MAPPING: Record<RecommendationKind, Intent> = {
  '': 'danger',
  add_on: 'primary',
  fallback: 'warning',
};

const RECOMMENDATION_PRODUCT_LABEL_MAPPING: Record<Product, ReactNode> = {
  [Product.UnsecuredLoan]: 'Unsecured loan',
  [Product.CreditCard]: 'Credit card',
  [Product.SecuredLoan]: 'Secured loan',
};

interface RecommendationItemProps {
  applicationID: string;
  recommendationKind: RecommendationKind;
  recommendationProduct: Product;
}

export const RecommendationItem: React.FC<RecommendationItemProps> = ({
  applicationID,
  recommendationKind,
  recommendationProduct,
}) => {
  return (
    <div className={styles.card}>
      <Tag
        round
        size="large"
        minimal
        intent={RECOMMENDATION_KIND_INTENT_MAPPING[recommendationKind]}
      >
        {RECOMMENDATION_KIND_LABEL_MAPPING[recommendationKind]}
      </Tag>
      <span className={styles.label}>
        {RECOMMENDATION_PRODUCT_LABEL_MAPPING[recommendationProduct]}
      </span>
      <CreateRecommendationItemButton
        applicationID={applicationID}
        recommendationProduct={recommendationProduct}
      />
    </div>
  );
};
